export class PaimonRestCatalogConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "uri",
            "baseName": "uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "warehouse",
            "baseName": "warehouse",
            "type": "string",
            "format": ""
        },
        {
            "name": "authMode",
            "baseName": "authMode",
            "type": "PaimonRestAuthMode",
            "format": ""
        },
        {
            "name": "credentialSecretArn",
            "baseName": "credentialSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "sigv4SigningRegion",
            "baseName": "sigv4SigningRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "sigv4SigningName",
            "baseName": "sigv4SigningName",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergDatabase",
            "baseName": "icebergDatabase",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergTable",
            "baseName": "icebergTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "extraRestOptions",
            "baseName": "extraRestOptions",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PaimonRestCatalogConfig.attributeTypeMap;
    }
    constructor() {
    }
}
